import { on } from 'delegated-events';
import { createFocusTrap, FocusTrap } from 'focus-trap';
import abort from '../../../javascripts/utils/abort';
import moveFocus from '../../../javascripts/utils/moveFocus';

let focusTrap: FocusTrap | null = null;

on('click', '.header__navigation-link[aria-controls]', (event) => {
  event.preventDefault();

  const { currentTarget: $link } = event;
  const target = $link.getAttribute('aria-controls') ?? abort();
  const $target = document.getElementById(target) ?? abort();
  const $header = $link.closest<HTMLElement>('.header') ?? abort();
  const expanded = $link.getAttribute('aria-expanded') === 'true';

  if ($header.offsetWidth < 1000) {
    $link.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    moveFocus(expanded ? $link : $target);
  } else {
    focusTrap?.deactivate();

    if (expanded) {
      return;
    }

    focusTrap = createFocusTrap($link.parentElement ? [$target, $link.parentElement] : $target, {
      initialFocus: false,
      escapeDeactivates: true,
      clickOutsideDeactivates: true,
      allowOutsideClick: true,
      returnFocusOnDeactivate: false,
      preventScroll: true,
      onDeactivate() {
        $link.setAttribute('aria-expanded', 'false');
        $target.toggleAttribute('hidden', true);
        moveFocus($link);
      },
      onActivate() {
        $target.toggleAttribute('hidden', false);
        $link.setAttribute('aria-expanded', 'true');
      },
      onPostActivate() {
        moveFocus($target);
      },
    });

    focusTrap.activate();
  }
});

on('click', '.header__button', (event) => {
  event.preventDefault();

  const { currentTarget: $button } = event;
  const target = $button.getAttribute('aria-controls') ?? abort();
  const $target = document.getElementById(target) ?? abort();
  const expanded = $button.getAttribute('aria-expanded') === 'true';

  focusTrap?.deactivate();

  if (expanded) {
    return;
  }

  focusTrap = createFocusTrap($button.parentElement ? [$target, $button.parentElement] : $target, {
    initialFocus: false,
    escapeDeactivates: true,
    clickOutsideDeactivates: true,
    allowOutsideClick: true,
    returnFocusOnDeactivate: false,
    preventScroll: true,
    onDeactivate() {
      $button.setAttribute('aria-expanded', 'false');
      $target.toggleAttribute('hidden', true);
      moveFocus($button);
    },
    onActivate() {
      $target.toggleAttribute('hidden', false);
      $button.setAttribute('aria-expanded', 'true');
    },
    onPostActivate() {
      moveFocus($target);
    },
  });

  focusTrap.activate();
});
